import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from '@/lib/cn';

import { focusRing } from './controlStyles';

interface Props extends RadixCheckbox.CheckboxProps {
  label: string;
}

/** Radix, not a native checkbox — §4: a native control cannot be styled consistently. */
export function Checkbox({ label, className, id, ...props }: Props) {
  return (
    <div className="flex items-center gap-2">
      <RadixCheckbox.Root
        id={id}
        className={cn(
          'flex size-4 items-center justify-center rounded border border-rule-control bg-paper',
          'data-[state=checked]:border-accent data-[state=checked]:bg-accent',
          focusRing,
          className,
        )}
        {...props}
      >
        <RadixCheckbox.Indicator>
          <Check size={12} strokeWidth={2} className="text-accent-fg" aria-hidden />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <label htmlFor={id} className="text-sm text-ink-900">
        {label}
      </label>
    </div>
  );
}
